import React from 'react';
import {max, histogram, range, quantile} from 'd3-array';
import {scaleLinear} from 'd3-scale';
import DistributionXAxis from './DistributionXAxis';
import DistributionYAxis from './DistributionYAxis';

const DistributionGraph = ({active_neighborhood, active_year, active_price, active_mode, formatters, active_probability, interpolators, browser_width}) => {

  const priceRoundhundthou = (value) => {
    if (active_probability === 1) {
      return Math.ceil(value/100000) * 100000;
    } else if (active_probability === 0) {
      return Math.floor(value/100000) * 100000;
    } else {
      return Math.round(value/100000) * 100000;
    }
  }

  const years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];

  let svg_width = 360;
  if (browser_width < 451) svg_width = browser_width;

  const svg_height = 200;

  const margins = {
    top: 20,
    right: 30,
    bottom: 30,
    left: 40
  }

  const inner_width = svg_width - margins.left - margins.right;
  const inner_height = svg_height - margins.top - margins.bottom;

  const year_index = years.indexOf(active_year);
  const samples = active_neighborhood.samples[year_index];
  // Round sample max up to nearest thousand, then add 200000 to offset low end of graph
  const samples_max = Math.ceil(max(samples)/100000) * 100000 + 200000;
  const each_sample_max = years.map((year,i) => max(active_neighborhood.samples[i]));
  const all_samples_max = max(each_sample_max);
  // const set_max = 4000000;
  const step_number = samples_max/100000;
  // const samples_step = Math.floor(samples_max/step_number);
  const samples_step = 100000;
  const x_range = range(0, samples_max, samples_step);

  const x = scaleLinear()
    // .domain([0,all_samples_max])
    // .domain([0,samples_max])
    .domain([0,8000000])
    .range([0,inner_width])

  const bins = histogram()
    .domain([0,samples_max])
    .thresholds(x_range)
    (samples);

  const y = scaleLinear()
    // .domain([0, (max(bins, function(d) { return d.length; }) * 1.1)/samples.length])
    .domain([0, 0.4])
    .range([inner_height,0])
    .nice()

  let cumulative_count = 0;
  let cumulative_array = bins.map((bin) => {
    cumulative_count += bin.length;
    return cumulative_count;
  });

  const range_map = x_range.map((value,i) => {
    let adjusted_value = cumulative_array[i]/samples.length;
    if (active_mode === 'Price') {
      adjusted_value = value/2000000;
    }
    return interpolators.chance(adjusted_value);
  });

  const bin_plots = bins.map((bin) => {
    let x = bin.x0;
    let width = bin.x1 - bin.x0;
    let height = bin.length/samples.length;
    return {x, width, height};
  })

  let price_line_x = x(active_price);
  if (active_mode === 'Price') price_line_x = x(priceRoundhundthou(active_neighborhood.properties.price));
  let bin_plots_x1s = bins.map((bin) => bin.x1);
  const bin_x_max = max(bin_plots_x1s);

  let bars = bin_plots.map((plot) => {
    let color = '#ccc';
    if (x(plot.x) < price_line_x) {
      color = '#777';
    }
    let bar_rect = <g
        key={plot.x}
        transform={`translate(${x(plot.x)},${y(plot.height)})`}
      >
        <rect
          className="ComboGraphBar"
          x="0"
          width={x(plot.width)}
          height={inner_height - y(plot.height)}
          fill={color}
          stroke={color}
        />
      </g>
    return bar_rect;
  })

  let price_lines;
  if (active_mode === 'Price') {
    price_lines = <g>
      <rect
        x={x(active_neighborhood.year_all_prices[year_index][0])}
        width={x(active_neighborhood.year_all_prices[year_index][2] - active_neighborhood.year_all_prices[year_index][0])}
        height={inner_height}
        fill="rgba(0,0,0,0.1)"
      />
      <line
        x1={x(active_neighborhood.properties.price)}
        x2={x(active_neighborhood.properties.price)}
        y1="0"
        y2={inner_height}
        stroke="#222"
      />
    </g>
  } else {
    price_lines = <line
      x1={price_line_x}
      x2={price_line_x}
      y1="0"
      y2={inner_height}
      stroke="black"
      opacity="0.8"
    />
  }

  return (
    <div className=""
      style={{
        height: svg_height
      }}
    >
      <svg
        style={{
          width: svg_width,
          height: svg_height,
        }}
      >
        <defs>
          <clipPath id="clipPath">
            <rect x="0" y="0" width={inner_width + 12} height={inner_height} />
          </clipPath>
        </defs>
        <g transform={`translate(${margins.left},${margins.top})`}>
          <rect
            x="0"
            y="0"
            width={inner_width + 12}
            height={inner_height}
            fill="#fafafa"
          />
          <DistributionXAxis
            x={x}
            formatters={formatters}
            inner_height={inner_height}
            svg_height={svg_height}
            margins={margins}
          />
          <DistributionYAxis
            y={y}
            formatters={formatters}
            svg_width={svg_width}
            margins={margins}
          />
          <g className="DistributionGraphBars"
            style={{
              clipPath: 'url(#clipPath)'
            }}
          >
            {bars}
          </g>
          {price_lines}
        </g>
      </svg>
    </div>
  )
}

export default DistributionGraph;


/** WEBPACK FOOTER **
 ** ./src/components/DistributionGraph.js
 **/